// extracted by mini-css-extract-plugin
module.exports = {"global_empty_body":"global_empty_body___2_tbx"};